module.exports = __webpack_public_path__ + "img/homework_littletitle_bg.6d9b3c62.png";